import { render, staticRenderFns } from "./fccNacionalidade.vue?vue&type=template&id=39be0fa5"
import script from "./fccNacionalidade.vue?vue&type=script&lang=js"
export * from "./fccNacionalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports